<template>
    <div>

        <!-- Banner -->
        <banner-generic :data="data.hero"></banner-generic>

        <!-- Form & Details -->
        <section class="padding--lg">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div>
                        <!-- Include text widget here -->
                            <!-- <h4 class="medium">Enquiry</h4> -->
                            <!-- <p>If you can’t find what you’re looking for, get in touch and we’ll get back to you as soon as possible.</p> -->
                            <div v-if="showThankYouMessage">
                                <div v-html="data.page.ThankYouMessage"></div>
                            </div>
                            <div v-else>
                                <div class="form-block">
                                    <sign-up-form  :form="data.form" />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <div
            v-for="(element, index) in data.elements"
            :key="index"
        >
            <component :is="element.vueName" :data="element"/>
        </div>

    </div>
</template>

<script>
    import { BannerGeneric, SignUpForm, Cta } from "../components";

    // elements
    import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";

    export default {
        name: "v-sign-up",
        components: {
            BannerGeneric,
            SignUpForm,
            Cta,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        },
        methods: {

        },
        data () {
            return {
                showThankYouMessage:false
            }
        },
        created() {

            if (window.location.href.indexOf("thankyou") > 1) {
                this.showThankYouMessage = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    .form-block {
        max-width: 700px;
    }

    .contact-content {
        background-color: #afccd7;
        padding: 3rem;
        top: -100px;
        position: relative;
    }

    .quicklinks {
        margin: 4rem 0;

        .container {
            border-top: 1px solid;
        }

        .link-card {
            // margin: 0 0 2rem 0;
        }
    }
</style>
